import { RootState } from '../../bll/store/store';

const getCustomersSelector = (state: RootState) => state.adminUsers.users;
const getUsersPageSelector = (state: RootState) => state.adminUsers.page;
const getUsersPagesCountSelector = (state: RootState) => state.adminUsers.pagesCount;
const getSelectedUser = (state: RootState) => state.adminUsers.selectedUser;

export { getCustomersSelector, getUsersPageSelector, getUsersPagesCountSelector, getSelectedUser };
